import { render, staticRenderFns } from "./TabelleRimborso.vue?vue&type=template&id=070bbc92&scoped=true"
import script from "./TabelleRimborso.vue?vue&type=script&lang=js"
export * from "./TabelleRimborso.vue?vue&type=script&lang=js"
import style0 from "./TabelleRimborso.vue?vue&type=style&index=0&id=070bbc92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070bbc92",
  null
  
)

export default component.exports